import { apiClient } from '@features/shared/api/client'
import type {
  CreatePreferenceGroupRequest,
  PreferenceGroupDetail,
  PreferenceGroupSummary,
  UpdatePreferenceGroupsRequest,
} from './contracts'

interface PreferenceGroupListParams {
  limit?: number
  offset?: number
}

export async function getPreferenceGroups(
  params: PreferenceGroupListParams = {}
): Promise<PreferenceGroupSummary[]> {
  const { data } = await apiClient.get<PreferenceGroupSummary[]>('/preference-groups', { params })
  return data
}

export async function getPreferenceGroupDetails(
  params: PreferenceGroupListParams = {}
): Promise<PreferenceGroupDetail[]> {
  const { data } = await apiClient.get<PreferenceGroupDetail[]>('/preference-groups/details', {
    params,
  })
  return data
}

export async function getPreferenceGroup(
  preferenceGroupId: string
): Promise<PreferenceGroupDetail> {
  const { data } = await apiClient.get<PreferenceGroupDetail>(
    `/preference-groups/${preferenceGroupId}`
  )
  return data
}

export async function createPreferenceGroup(
  payload: CreatePreferenceGroupRequest
): Promise<PreferenceGroupDetail> {
  const { data } = await apiClient.post<PreferenceGroupDetail>('/preference-groups', payload)
  return data
}

export async function updatePreferenceGroups(
  payload: UpdatePreferenceGroupsRequest
): Promise<PreferenceGroupDetail[]> {
  const { data } = await apiClient.patch<PreferenceGroupDetail[]>('/preference-groups', payload)
  return data
}
